import {IMultiOccurrenceOptions} from '../../../../../core/services/multi-occurrence.service';
import {IMenuClass} from '../../../../../core/services/menu/menu.service';
import {IRoute} from '../../../../../core/interfaces/route.interface';
import {IMenuItemForageClass} from '../../../../../core/services/menu/menu-item-forage.service';

interface IPageMr0224 {
    multiOccurrenceOptions: IMultiOccurrenceOptions;
}

/* @ngInject */
export default function Mr0224Controller(mr2028Route: IRoute,
                                         Menu: IMenuClass,
                                         MenuItemForage: IMenuItemForageClass) {
    const vm: IPageMr0224 = this;

    vm.multiOccurrenceOptions = {
        navigatePage: mr2028Route.NAME,
        actionsNouveaux: new Menu([
            new MenuItemForage(mr2028Route.NAME)
        ]),
        fonctions: {
            pagination: true,
            rechercheCollapsable: false,
            edition: false,
            supprime:false
        },
        colonnesVisibles: [
            {nom: 'mpdcod'      , largeur: 100},
            {nom: 'mpddsc'      , largeur: 250},
            {nom: 'mpemsg'      , largeur: 350},
            {nom: 'mpddoc'      , largeur: 125},
        ],
        pagination: {
            nombreElementPage: 50,
            nbElementsPossibles: [50, 100, 250, 500]
        },
    };
}
